// src/hooks/useSession.js
import { useState, useEffect } from "react";

export const useSession = () => {
  const [isLogin, setIsLogin] = useState(localStorage.getItem("islogin"));
  const [role, setRole] = useState(localStorage.getItem("role"));
  const [name, setName] = useState(localStorage.getItem("name"));
  const [userid, setUserid] = useState(localStorage.getItem("userid"));

  // Keep state in sync if localStorage changes
  useEffect(() => {
    const syncSession = () => {
      setIsLogin(localStorage.getItem("islogin"));
      setRole(localStorage.getItem("role"));
      setName(localStorage.getItem("name"));
      setUserid(localStorage.getItem("userid"));
    };

    window.addEventListener("storage", syncSession);
    return () => window.removeEventListener("storage", syncSession);
  }, []);

  return { isLogin, role, name, userid };
};
